var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13831 14.8854C7.2933 12.7084 10.5017 9.46731 14.7635 5.16201C14.9974 5.39018 15.1043 5.50952 15.2979 5.75932C11.0624 10.0381 7.87232 13.2607 5.72773 15.4272C5.42645 15.1768 5.3176 15.0821 5.13831 14.8854ZM16.7999 10.0734C16.7999 6.27623 13.7546 3.1999 9.9999 3.1999C6.24523 3.1999 3.1999 6.27623 3.1999 10.0734C3.1999 13.8704 6.24531 16.9468 9.9999 16.9468C13.7545 16.9468 16.7999 13.8704 16.7999 10.0734ZM17.5999 10.0734C17.5999 14.3104 14.1982 17.7468 9.9999 17.7468C5.80165 17.7468 2.3999 14.3104 2.3999 10.0734C2.3999 5.83621 5.80157 2.3999 9.9999 2.3999C14.1982 2.3999 17.5999 5.83621 17.5999 10.0734Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.67658a842786f3adacc164cc533f0b12.svg";
export { ForwardRef as ReactComponent };